<div class="text-info">
    <p><b>{{'report_step_date' | translate}}</b>: {{info}}</p>
</div>

